module.exports = __webpack_public_path__ + "img/20191002133450360截图20191002132818157.d973ad76.jpg";